import { Stack, TextField } from '@mui/material'

import { OneTimeReminderInfoViaEnum } from '../../sdk'

export const ReminderContent = ({
  vias,
  title,
  setTitle,
  message,
  setMessage
}: {
  vias: OneTimeReminderInfoViaEnum[]
  title: string
  setTitle: (title: string) => void
  message: string
  setMessage: (message: string) => void
}) => {
  return (
    <Stack spacing={2}>
      {vias.includes(OneTimeReminderInfoViaEnum.Email) && (
        <TextField
          value={title}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setTitle(event.target.value)
          }}
          label="Title"
        />
      )}
      <TextField
        value={message}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setMessage(event.target.value)
        }}
        label="Message"
        multiline
        minRows={4}
      />
    </Stack>
  )
}
